import React, { useEffect, useState } from 'react';
import './AdminNavbar.css'
import { display } from '@mui/system';
import logo  from '../Assets/logonew.png'
import ReportIcon from '@mui/icons-material/Report';

const AdminNavBar = () => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  const [showDropdown, setShowDropdown] = useState(false);
  
  const handleReturnStockClick = () => {
    setShowDropdown(!showDropdown); // Toggle the dropdown
  };

  const selectedLanguage = sessionStorage.getItem('selectedLanguage');
  
  
  return (
    
    <div className={`sidebar ${isOpen ? 'open' : ''}`}  style={{display:"flex",flexDirection:"column",flex:"1",overflow:"scroll"}}>
    <div className="logo-details mt-4" >
      <i className='bx bxs-landscape'></i>
      <div className="logo_name" style={{marginLeft: "-32px",color: "#59e5ea", textShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",fontSize: "24px", fontWeight: "bold", letterSpacing: "1px", fontFamily: "Arial, sans-serif"}}>
  Dairy Connect
</div>
      <i className={`fa ${isOpen ? 'fa-solid fa-bars' : 'fa-solid fa-bars'}`} id="btn" onClick={toggleSidebar}></i>
    </div>
    <div className="sidebar-content">
    <ul className="nav-list mb-5" >
      {/* <li>
        <i className='bx bx-search' onClick={toggleSidebar}></i>
        <input type="text" placeholder="Search..." />
        <span className="tooltip">Search</span>
      </li> */}
      <li >
        <a href="/#/adminDashboard1"   className="active ">
          <i className='fa fa-line-chart'></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'डॅशबोर्ड' : 'Dashboard'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'डॅशबोर्ड' : 'Dashboard'}</span>
      </li>

      <li>
        <a href="/#/productMaster1">
        <i class="fa-brands fa-product-hunt"></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'उत्पादन मास्टर' : 'Product Master'}</span>
        </a>
        <span className="tooltip">{selectedLanguage  === 'Marathi' ? 'उत्पादन मास्टर' : 'Product Master'}</span>
      </li>
      
      <li>
        <a href="/#/customerMaster1">
        <i class="fa-solid fa-user"></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'ग्राहक मास्टर' : 'Customer Master'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'ग्राहक मास्टर' : 'Customer Master'}</span>
      </li>

      <li>
        <a href="/#/employeeMaster1">
        <i class="fa-solid fa-person-biking"></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'कर्मचारी मास्टर' : 'Employee Master'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'कर्मचारी मास्टर' : 'Employee Master'}</span>
      </li>

      <li>
        <a href="/#/empToCustAllotment">
        <i class="fa-solid fa-users"></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'कर्मचारी ते ग्राहक वाटप' : 'Emp To Cust Allotment'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'कर्मचारी ते ग्राहक वाटप' : 'Employee To Customer Allotment'}</span>
      </li>

      <li>
        <a href="/#/orderAllotment1">
        <i class="fa-brands fa-first-order"></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'ऑर्डर वाटप' : 'Order Allotment'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'ऑर्डर वाटप' : 'Order Allotment'}</span>
      </li>

      <li>
        <a href="/#/dailyStock1">
        <i class="fa-solid fa-cart-shopping"></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'दैनिक साठा' : 'Daily Stock'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'दैनिक साठा' : 'Daily Stock'}</span>
      </li>

      <li>
        <a href="/#/billingProcess1">
        <i class="fa-solid fa-file-invoice"></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'बिलिंग प्रक्रिया' : 'Billing Process'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'बिलिंग प्रक्रिया' : 'Billing Process'}</span>
      </li>

      <li >
        <a href="/#/payment1">
        <i class="fa-regular fa-credit-card"></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'पेमेंट' : 'Payment'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'पेमेंट' : 'Payment'}</span>
      </li>

      <li >
        <a href="/#/returnStock">
        <i className="fa-solid fa-layer-group"></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'उत्पादन परत केले' : 'Returned Product'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'उत्पादन परत केले' : 'Returned Product'}</span>
      </li>

      <li >
        <a href="/#/expense">
        <i class="fa-solid fa-money-bill"></i> 
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'खर्च' : 'Expense'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'खर्च' : 'Expense'}</span>
      </li>
      
      <li >
        <a href="/#/dashboardReport">
      <i> <ReportIcon /></i>
          <span className="links_name">{selectedLanguage === 'Marathi' ? 'अहवाल' : 'Report'}</span>
        </a>
        <span className="tooltip">{selectedLanguage === 'Marathi' ? 'अहवाल' : 'Report'}</span>
      </li>



     







      {/* Other list items */}
      <li className="profile ">
        <div className="profile-details" style={{paddingLeft:"32px"}}>
          <img className='w-100 mx-1' src={logo} alt="profileImg" />
          <div className="name_locality text-center m-0">
            <div className="locality text-light">Developed By</div>
            <div className="name text-light">TechnoAarv Solution</div>
          </div>
        </div>
      </li>
    </ul>
    </div>
  </div>
  
);
};


export default AdminNavBar;
